import { call, put, takeEvery } from 'redux-saga/effects';

import {
  OFFERS_AMOUNT_ASK,
  offersAmountFailed,
  offersAmountReceived
} from 'src/app/redux/actions/offers';
import offersApi from 'src/app/api/offersApi';


function offersAmount(requestForOffersAmount) {
  return function* offersAmountGenerator() {
    const offersRequestWithDispatchers = yield requestForOffersAmount()
      .then(function* onSuccess (amount) {
        return yield put(offersAmountReceived(amount));
      })
      .catch(function* onError ({ message }) {
        yield put(offersAmountFailed(message));
      });

    yield call(() => offersRequestWithDispatchers);
  };
}

export { offersAmount };

export default [
  takeEvery(OFFERS_AMOUNT_ASK, offersAmount(offersApi.requestForAmount))
];
